import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'

type DiscontinuedContentProps = {
  record: any
  recordDetails?: any
}

const DiscontinuedContent = ({
  record,
  recordDetails
}: DiscontinuedContentProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  return (
    <>
      <Label level={2}>{t('DISCONTINUED')}</Label>
      <Value>{recordDetails?.discontinuedReason || 'Because of...'}</Value>
    </>
  )
}

const Label = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
  font-weight: 500;
`

const Value = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
  font-weight: 400;
`
export default DiscontinuedContent
